// Admin > Price Setup "A–Z" and "Most used" buttons: rearrange a list once;
// the admin can still drag afterwards, then Save.

/** Alphabetical by name (case-insensitive, numbers in order). */
export const sortByName = <T>(items: T[], name: (item: T) => string): T[] =>
  [...items].sort((a, b) =>
    (name(a) ?? "").trim().localeCompare((name(b) ?? "").trim(), undefined, {
      sensitivity: "base",
      numeric: true,
    })
  );

/**
 * Most used first (pieces on bills in the window); items used equally, or
 * not at all, keep their current order.
 */
export const sortByUsage = <T>(items: T[], uses: (item: T) => number): T[] =>
  items
    .map((item, index) => ({ item, index, count: uses(item) || 0 }))
    .sort((a, b) => b.count - a.count || a.index - b.index)
    .map(({ item }) => item);

/** True when no item in the list was used in the window. */
export const hasNoUsage = <T>(items: T[], uses: (item: T) => number) =>
  items.every((item) => !(uses(item) > 0));
